var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.48185 10.4888L5.54078 10.5477C7.46086 12.4678 10.5739 12.4678 12.494 10.5477V10.5477C14.4141 8.6276 14.4141 5.51454 12.494 3.59446L12.3761 3.47661C10.4561 1.55653 7.34301 1.55653 5.42293 3.47661V3.47661C3.50285 5.39669 3.50285 8.50975 5.42293 10.4298L5.48185 10.4888ZM5.48185 10.4888L1.94632 14.0243",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.f24e5e54edee5a029d74a26e13ac80aa.svg";
export { ForwardRef as ReactComponent };